<div class="wrap-content">
  <div class="content" matTooltip="Select" role="button" tabindex="0" aria-haspopup="true" aria-expanded="false" aria-label="Select">
    <div class="container">
      <div role="checkbox" class="checkbox-container">
        <mat-checkbox color="primary" [formControl]="checkboxControl" [(indeterminate)]="indeterminate"></mat-checkbox>
      </div>
      <div role="button">
        <button mat-icon-button [matMenuTriggerFor]="menuList">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #menuList="matMenu" yPosition="below">
          @for (item of menu; track item; let i = $index) {
            <!-- [disabled]="selectedIndex === i" -->
            <button mat-menu-item (click)="menuHandler(item)">{{item | translate}}</button>
          }
        </mat-menu>
      </div>
    </div>
  </div>
</div>